import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Typography,
  CircularProgress,
  // Button,
} from '@material-ui/core';

import DashboardLayout from '../../dashboard/components/DashboardLayout';
import Alert from '../../common/components/Alert';
import ActivityPageItem from '../components/ActivityPageItem';
import ActionDialog from '../components/ActionDialog';

import * as activitiesActions from '../actions';
// import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


class ManageActivityItem extends Component {
  state = {
    dialog: false,
    actionType: null,
    confirmVisible: true,
  }

  componentDidMount() {
    if (this.props.match.params.type === 'shortlists') {
      document.title = 'Manage shortlist';
    }
    this.props.getActivityItem(
      this.props.token,
      this.props.match.params.type,
      this.props.match.params.slug,
    );
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  // backtoActivityList = () => {
  //   this.props.history.replace(
  //     formatRoute(
  //       routes.ACTIVITIES,
  //       { type: this.props.match.params.type },
  //     ),
  //   );
  // }

  viewProfile = (slug) => {
    this.props.history.push(
      formatRoute(
        routes.VIEW_PROFILE,
        { uuid: slug },
      ),
    );
  }

  confirmAction = () => {
    this.setState({
      confirmVisible: false,
    });
    if (this.state.actionType === 'delete') {
      this.props.deleteActivity(
        this.props.token,
        this.props.match.params.type,
        this.props.activity.id,
        this.props.history,
      );
    } else {
      this.props.replyActivity(
        this.props.token,
        this.props.match.params.type,
        this.props.activity.id,
        this.state.actionType,
      );
    }
  }

  deleteActivity = () => {
    this.setState({
      dialog: true,
      actionType: 'delete',
    });
  }

  closeDialog = () => {
    this.setState({
      dialog: false,
      confirmVisible: true,
    });
  }

  replyActivity = (reply) => {
    this.setState({
      dialog: true,
      actionType: reply,
    });
  }

  render() {
    const type = this.props.match.params.type;  // eslint-disable-line

    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let item = null;
    if (this.props.activity) {
      item = (
        <ActivityPageItem
          item={this.props.activity}
          type={this.props.match.params.type}
          viewProfile={this.viewProfile}
          deleteActivity={this.deleteActivity}
          replyActivity={this.replyActivity}
        />
      );
    }

    return (
      <DashboardLayout
        isAuthenticated
        activeLink="home"
        dashActiveLink={type}
        user={this.props.user}
      >
        {/* <div className={classes.padding10XS}>
          <Button size="small" variant="outlined" color="secondary"
            onClick={this.backtoActivityList}>
            Back
          </Button>
        </div> */}
        {/* <br /> */}
        {loading}
        {errorAlert}
        {item}
        <ActionDialog
          type={this.props.match.params.type}
          open={this.state.dialog}
          close={this.closeDialog}
          actionType={this.state.actionType}
          confirm={this.confirmAction}
          item={this.props.activity}
          loading={this.props.actionLoading}
          actionError={this.props.actionError}
          confirmVisible={this.state.confirmVisible}
        />
      </DashboardLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.activities.loading,
    error: state.activities.error,
    activity: state.activities.activity,
    actionLoading: state.activities.actionLoading,
    actionError: state.activities.actionError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(activitiesActions.onUnmount()),
    getActivityItem: (token, type, slug) => dispatch(
      activitiesActions.getActivityItem(token, type, slug),
    ),
    deleteActivity: (token, type, id, history) => dispatch(
      activitiesActions.deleteActivity(token, type, id, history),
    ),
    replyActivity: (token, type, id, reply) => dispatch(
      activitiesActions.replyActivity(token, type, id, reply),
    ),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageActivityItem));



// WEBPACK FOOTER //
// ./src/activities/containers/ManageActivityItem.js